import { render, staticRenderFns } from "./CookieConsentLogs.vue?vue&type=template&id=59f08077&scoped=true"
import script from "./CookieConsentLogs.vue?vue&type=script&lang=js"
export * from "./CookieConsentLogs.vue?vue&type=script&lang=js"
import style0 from "./CookieConsentLogs.vue?vue&type=style&index=0&id=59f08077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f08077",
  null
  
)

export default component.exports